import { createSelector } from 'reselect'
import { selectKbProduct } from './selectKbProduct'
import { selectPlans } from './selectPlans'

export const selectCurrentKbPlan = createSelector(
  selectKbProduct,
  selectPlans,
  (product, plans) => {
    return plans.find(p => p.product === 'kb' && p.planId === product.plan)
  }
)
